<template>
  <div id="app" @click='click' v-bind:class="{'izk-popfix': isScroll}" >
    <div class="izk-loading fix vcbox" v-if="isShowLoading">
        <p class="txt">正在努力奔跑中...</p>
    </div>
    <Header></Header>
    <router-view>

    </router-view>
    <Footer></Footer>
    <Toast></Toast>
    <SideBar></SideBar>
    <LocationChange></LocationChange>
</div>
</template>
<script>
    import '@/components/common/css/wap_reset.css';
    import '@/components/common/css/common.css';
    import '@/components/common/css/index/module.css';
    import '@/components/common/css/index/index.css';
    import '@/components/common/css/city.css';
    import Header from '@/components/public/header/Header.vue';
    import Footer from '@/components/public/footer/Footer.vue';
    import Toast from '@/components/public/toast/Toast.vue';
    import SideBar from '@/components/public/sideBar/SideBar.vue';
    import LocationChange from '@/components/public/locationChange/LocationChange.vue';
    import {mapState} from 'vuex';
    import vue from 'vue';
    import {isWeChat, getSign} from './common/libs/common.js';
    import api from './common/libs/api.js';
    import utils from '@/common/libs/utils'
    import CityCodeData from '@/common/libs/CityCodeData';
    import localforage from 'localforage';
export default {
  name: 'App',
  components: {
        Header,
        Footer,
        Toast,
        SideBar,
        LocationChange
  },
  data(){
        return {

        }
  },
  computed: mapState({
        isScroll: state => state.home.isScroll,
        token: state => state.mine.token,
        isShowLoading: state => state.home.isShowLoading
  }),
  watch: {
        $route(to, from){
          var noShares = ['feedbackInfo', 'studentInfo', 'chooseTime', 'diaDetail', 'login'];
          if (isWeChat(navigator)&&noShares.indexOf(to.name)==-1&&noShares.indexOf(from.name)==-1){
            setTimeout(function () {
              window.location.href = window.location.href;
              this.wechat();
            }, 100);
          }
        },
        token: {
          handler: function(newVal, oldVal){
            if (newVal == 2){
              //token过期，处理
              this.$store.commit('addMine', {state: {}});

                    localforage.removeItem('token');
                    localforage.removeItem('izk-user');
                    localforage.removeItem('izk-grade-list-grid');
                    utils.cookie.del('token', '.izhikang.com', '/');
                    localStorage.removeItem('token');
                }
            },
            deep: true
        }
  },
  methods: {
        click () {
          if (this.$route.name === 'faceToface') {
            this.clearFaceTime();
          }
        },
        netWorkError(){  //处理断网情况的，已经绑定到全局
          this.$store.dispatch('toast', {title: '网络不给力，请稍后重试', show: true});
          this.$store.commit('changeNetWork', false);
        },
        wechat(){
          let vm = this;
          let win = window;
          let doc = document;

          api.apiMethod.getSignPackage.post({
            url: location.href,
            fullurl: 1
          }).then(res => {
            if (res.data.appId){
              wx.config({
                debug: process.env.NODE_ENV  != 'production',
                appId: res.data.appId,
                timestamp: `${  res.data.timestamp}`,
                nonceStr: `${res.data.nonceStr  }`,
                signature: `${res.data.signature  }`,
                jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'] // 功能列表，我们要使用JS-SDK的什么功能
              });

              wx.ready(function () {
                // 2. 分享接口
                // 2.1 监听“分享给朋友”，按钮点击、自定义分享内容及分享结果接口
                wx.onMenuShareAppMessage({
                  title: doc.title,
                  desc: vm.$store.state.meta.description||doc.title,
                  link: win.location.href,
                  imgUrl: vm.$store.state.meta.favicon || 'https://static4.izhikang.com/material/generator/izk_logo1604459196832.png',
                  trigger: function (res) {
                    // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                    //alert('用户点击发送给朋友');
                  },
                  success: function (res) {
                    //alert('已分享');
                    callback&&callback({name: 'onMenuShareAppMessage', result: res});
                  },
                  cancel: function (res) {
                    //alert('已取消');
                  },
                  fail: function (res) {
                    //alert(JSON.stringify(res));
                    callback&&callback({name: 'onMenuShareAppMessage', result: res});
                  }
                });

                // 2.2 监听“分享到朋友圈”按钮点击、自定义分享内容及分享结果接口
                wx.onMenuShareTimeline({
                  title: doc.title,
                  desc: doc.title,
                  link: win.location.href,
                  imgUrl: vm.$store.state.meta.favicon||'https://static4.izhikang.com/material/generator/izk_logo1604459196832.png',
                  trigger: function (res) {
                    // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
                    //alert('用户点击分享到朋友圈');
                  },
                  success: function (res) {
                    //alert('已分享');
                    callback&&callback({name: 'onMenuShareTimeline', result: res});
                  },
                  cancel: function (res) {
                    //alert('已取消');
                  },
                  fail: function (res) {
                    //alert(JSON.stringify(res));
                    callback&&callback({name: 'onMenuShareTimeline', result: res});
                  }
                });
              })
            } else {
              console.log(res);
            }
          })
        }
    },
    beforeMount(){
       var city = CityCodeData.getCityByShort(this.$route.params.city);

        var ename = this.$route.params.city;
        
        if (city) {
          utils.cookie.set('cityCode', city.city_code, '.izhikang.com', '/', 24*7);
        }
        if (ename && city.first_word !== ename){
          this.$router.replace('/404');
        }
    },
    mounted () {
        vue.prototype.netWorkError = this.netWorkError;
        if (isWeChat(navigator)&&this.$route.name!='feedbackInfo'){
            this.wechat();
        }
      //获取乐语链接commons
      this.$store.dispatch('fetchCommons');
      //对接美洽
              (function (m, ei, q, i, a, j, s) {
            m[i] = m[i] || function () {
              (m[i].a = m[i].a || []).push(arguments);
            };
            j = ei.createElement(q),
              s = ei.getElementsByTagName(q)[0];
            j.async = true;
            j.charset = 'UTF-8';
            j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t';
            s.parentNode.insertBefore(j, s);
          })(window, document, 'script', '_MEIQIA');
          _MEIQIA('entId', 6224);//173941  正式：6224
        //   _MEIQIA('getInviting', handleInviting);
        //   _MEIQIA('allSet', handleAllSet);
        //   _MEIQIA('getPanelVisibility', handlePanelVisibility);
          _MEIQIA('withoutBtn');
            //对接集团用户中心配置
        window.TAL_UC.rankConfig({
        'client-id': '171201' // client-id由平台发放权限码，接入之前向平台申请
        })
        window.TAL_UC.configNVC({
        renderToEle: '#captcha',
        isH5: true,
        onloadCallback: function () {
            console.log('配置完成')
        },
        failCallback: function () {
            console.log('error')
        }
        })   
    }
};
</script>


// WEBPACK FOOTER //
// src/App.vue